import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function Campaigns(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      width={width || "20"}
      height={height || "22"}
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8334 5.83887H9.16675V9.13887H10.8334V5.83887Z"
        fill={color || "#bbb"}
      />
      <path
        d="M10.8334 14.0139H9.16675V17.3139H10.8334V14.0139Z"
        fill={color || "#bbb"}
      />
      <path
        d="M18.3333 6.05H1.66667C1.22464 6.05 0.800716 5.87616 0.488155 5.56673C0.175595 5.25729 0 4.83761 0 4.4L0 1.65C0 1.21239 0.175595 0.792709 0.488155 0.483274C0.800716 0.173839 1.22464 0 1.66667 0L18.3333 0C18.7754 0 19.1993 0.173839 19.5118 0.483274C19.8244 0.792709 20 1.21239 20 1.65V4.4C20 4.83761 19.8244 5.25729 19.5118 5.56673C19.1993 5.87616 18.7754 6.05 18.3333 6.05ZM2.49889 1.925V4.125H17.4989V1.925H2.49889Z"
        fill={color || "#bbb"}
      />
      <path
        d="M18.3333 14.0251H1.66667C1.22464 14.0251 0.800716 13.8513 0.488155 13.5418C0.175595 13.2324 0 12.8127 0 12.3751L0 9.6251C0 9.18749 0.175595 8.76781 0.488155 8.45837C0.800716 8.14894 1.22464 7.9751 1.66667 7.9751H18.3333C18.7754 7.9751 19.1993 8.14894 19.5118 8.45837C19.8244 8.76781 20 9.18749 20 9.6251V12.3751C20 12.8127 19.8244 13.2324 19.5118 13.5418C19.1993 13.8513 18.7754 14.0251 18.3333 14.0251ZM2.49889 9.9001V12.1001H17.4989V9.9001H2.49889Z"
        fill={color || "#bbb"}
      />
      <path
        d="M18.3333 22H1.66667C1.22464 22 0.800716 21.8261 0.488155 21.5167C0.175595 21.2072 0 20.7876 0 20.35L0 17.6C0 17.1623 0.175595 16.7427 0.488155 16.4332C0.800716 16.1238 1.22464 15.95 1.66667 15.95H18.3333C18.7754 15.95 19.1993 16.1238 19.5118 16.4332C19.8244 16.7427 20 17.1623 20 17.6V20.35C20 20.7876 19.8244 21.2072 19.5118 21.5167C19.1993 21.8261 18.7754 22 18.3333 22ZM2.49889 17.875V20.075H17.4989V17.875H2.49889Z"
        fill={color || "#bbb"}
      />
    </svg>
  );
}
